import axios from "axios";
import * as AppSettingsService from "./AppSettingsService";
import {
  ITripRulesValidationInput,
  IRulesValidationResponse,
  IAliasesCareRecivers,
  ITripCostRequest,
  IMemberTrip,
  ITripCostResponse,
  IUpdateTripCostRequest,
  IUpdateTripResponse,
  IWandaServiceArea,
  WandaTripCreationDetails,
  WandaTripSummaryCostDetails,
} from "../types/TripTypes";
import moment from "moment";
import {
  IFavoritesRequest,
  IUpsertPersonOrgRelData,
} from "../components/ServiceUsers/Interfaces/ITripDetails";
import { UpsertCreateReservationRequest, UpsertReservationResponse } from "../types/TripTypesV2";
const appSettings = AppSettingsService;

export const TripRulesValidation = async (
  data: ITripRulesValidationInput
): Promise<IRulesValidationResponse> => {
  try {
    const response = await axios.post(
      `${appSettings.getAppApiUrl()}/membertrips/Protocol/v1/RulesValidation`,
      data,
      { headers: { "x-personId": data.personId } }
    );
    return response.data;
  } catch (error:any) {
    if (error?.response?.data[0]?.code === 603) {
      throw new Error("InvalidDate");
  } else {
    throw error;
  }
  }
};

export const getAliasesByCareReceiverId = async (
  careReceiverId: number
): Promise<IAliasesCareRecivers> => {
  try {
    const response = await axios.get(
      `${appSettings.getAppApiUrl()}/personorg/personadmin/v1/aliases/${careReceiverId}`
    );
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const createReservation = async (
  data: UpsertCreateReservationRequest,
  personId: number
): Promise<UpsertReservationResponse[]> => {
  try {
    const response = await axios.post(
      `${appSettings.getAppApiUrl()}/membertrips/Member/v1/UpsertReservation`,
      data,
      {
        headers: { "x-personId": personId },
      }
    );
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const GetDuplicatedDates = async (
  startDate: string,
  endDate: string
): Promise<string[]> => {
  try {
    const response = await axios.get(
      `${appSettings.getAppApiUrl()}/membertrips/member/v1/getmembertrips?startDate=${startDate}&endDate=${endDate}`
    );
    const finalResult: string[] = [];
    const rs = response.data;
    rs?.memberTrips?.map((item: IMemberTrip) => {
      const tripDate = item.appointmentDate.split("T")[0];
      finalResult.push(tripDate);
      finalResult.push(moment(tripDate).format("MM/DD/YYYY"));
    });
    return finalResult;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const GetCostDetailsByAddressList = async (
  data: ITripCostRequest[], personId: number
): Promise<ITripCostResponse> => {
  try {
    const response = await axios.post(
      `${appSettings.getAppApiUrl()}/ccp/Trip/v1/GetTripCostByAddress`,
      data,
      { headers: { "x-personId": personId } }
    );
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const updateTripCostByBookingId = async (
  data: IUpdateTripCostRequest
): Promise<IUpdateTripResponse> => {
  try {
    const response = await axios.post(
      `${appSettings.getAppApiUrl()}/ccp/Trip/v1/UpdateTripCost`,
      data,
      { headers: { "x-personId": data.personId } }
    );
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getWandaServiceArea = async (
  zipCode?: string,
  recaptchaToken?: string
): Promise<IWandaServiceArea[]> => {
  try {
    const response = await axios.get(
      `${appSettings.getAppApiUrl()}/ccp/Registration/v1/GetWandaServiceArea?zipcode=${zipCode}&recaptchaToken=${recaptchaToken}`
    );
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const addTripAsFavorite = async (
  data: IFavoritesRequest
): Promise<IUpdateTripResponse> => {
  try {
    const response = await axios.post(
      `${appSettings.getAppApiUrl()}/ccp/Trip/v1/UpdateFavorite`,
      data
    );
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const upsertPersonOrganizationRel = async (
  data: IUpsertPersonOrgRelData
): Promise<number> => {
  try {
    const response = await axios.post(
      `${appSettings.getAppApiUrl()}/personorg/personadmin/v1/upsertpersonorganizationrel`,
      data,
      { headers: { "x-personId": data.personId } }
    );
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const updateWandaTripCreationDetails = async (
  data: WandaTripCreationDetails,
  personId: number
): Promise<WandaTripSummaryCostDetails> => {
  try {
    const response = await axios.post(
      `${appSettings.getAppApiUrl()}/ccp/Trip/v1/UpdateWandaTripDetails`,
      data,
      { headers: { "x-personId": personId } }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
